import { useState } from 'react';
import { parseWeb3Response, submitWeb3Form } from '../utils/web3forms';

/**
 * Shared Web3Forms submit handler for site forms.
 * @param {{
 *   subject?: string;
 *   successMessage?: string;
 *   onSuccess?: () => void;
 *   beforeSubmit?: (formData: FormData) => void;
 * }} options
 */
export function useWeb3Form({
  subject,
  successMessage = 'Thank you. Your message has been sent.',
  onSuccess,
  beforeSubmit,
} = {}) {
  const [status, setStatus] = useState('');

  const submitting = status === 'Sending...';
  const isSuccess = Boolean(status && !submitting && status === successMessage);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('Sending...');

    const form = e.currentTarget;
    const formData = new FormData(form);

    if (subject) {
      formData.set('subject', subject);
    }

    beforeSubmit?.(formData);

    try {
      const response = await submitWeb3Form(formData);
      const result = await parseWeb3Response(response);

      if (result.success) {
        setStatus(successMessage);
        form.reset();
        onSuccess?.();
      } else {
        setStatus(result.message || 'Something went wrong. Please try again.');
      }
    } catch {
      setStatus('Unable to send right now. Please try again or call us.');
    }
  };

  return {
    handleSubmit,
    status,
    setStatus,
    submitting,
    isSuccess,
    isError: Boolean(status && !submitting && !isSuccess),
  };
}
